// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__103z7","buttons":"styles_buttons__DQ7YX"};